import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { addMessage } from 'store/actions/messages';
import { Box, Button, Heading } from 'grommet';
import * as moment from 'moment-timezone';

class WelcomeHeading extends Component {

  constructor(props) {
    super(props);
    this.state ={
      timeInterval: null,
      currentTime: null,
      submitted: false,
    };
  }

  componentDidMount() {
    const timeInterval = setInterval( () => {
      const now = moment().tz("America/Los_Angeles");
      this.setState({
        currentTime : <span>{now.format('MMMM Do')}<br />{now.format('h:mm a').replace('am', 'a.m.').replace('pm', 'p.m.')}</span>,
      })
    },1000);
    this.setState({ timeInterval });
  }

  componentWillUnmount() {
    if (this.state.timeInterval!==null) {
      clearInterval(this.state.timeInterval);
    }
  }

  render() {

    const { contact, /* disabled, */ mobileMode, submitForm } = this.props;
    const { currentTime, submitted } = this.state;

    const { image_URL } = contact;
    let contactImage = null;
    if (image_URL) {
      const elem = document.createElement('textarea');
      elem.innerHTML = image_URL;
      contactImage = elem.value;
    }


    return (
      <Box className="WelcomeHeading" pad="small" justify="between" align="center" direction="row-responsive" wrap>
        <Box flex basis="1/3" style={{ textAlign: mobileMode ? 'center' : 'left' }}>
          <Box direction="row">
            {contactImage &&
              <Box className="contact-image" border={{ side: "all", size: "small" }} margin={{ right: "small" }}>
                <img src={contactImage} alt="Contact profile" />
              </Box>
            }
            <Box justify="center">
              <Heading level="2" margin="none">
                Welcome<br />{contact===null ? '' : contact.display_name}
              </Heading>
            </Box>
          </Box>
        </Box>
        <Box flex basis="1/3" style={{ textAlign: 'center' }}>
          <Heading level="2" margin="none">
            {currentTime}
          </Heading>
        </Box>
        <Box flex basis="1/3" style={{ textAlign: mobileMode ? 'center' : 'right' }}>
          <div>
            <Button margin="none" label="I'm Done" onClick={() => { this.setState({ submitted: true }); submitForm(); }} disabled={submitted} primary={true} />
          </div>
        </Box>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth: { contact }, display: { mobileMode } } = state;
  return {
    contact,
    mobileMode,
  };
}

const mapDispatchToProps = dispatch => {

  return {
    handleMessage: (message, variant=null, logout=false) => dispatch(addMessage(message, variant, logout)),
    submitForm: () => dispatch(submit('checkin')),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeHeading);